












































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {Route} from "vue-router";
import {Form as ElForm, Input} from "element-ui";
import {UserModule} from "@/store/modules/user";
import {isValidUsername} from "@/utils/validate";
import {ConnectionTypes} from "@/api/enums";
import {isGuacAuthenticatedForTerminal, isGuacAuthenticatedForDesktop, authenticateGuacTerminal, authenticateGuacDesktop} from "@/utils/timeHelpers";

@Component({
  name: "Terminal"
})
export default class extends Vue {
  private dialogVisible: boolean = false;
  private actionOptions = ["Start", "Stop", "Reset", "Terminate"];
  private connectionType: ConnectionTypes = ConnectionTypes.SSH;
  private modalTitle: string = "";
  private modalMessage: string = "";

  created() {
    document.addEventListener("click", this.refocusGuacamole);
    document.addEventListener("keydown", this.refocusGuacamole);
    this.connectionType = this.$router.currentRoute.meta.title === "CyberLAB Terminal" ? ConnectionTypes.SSH : ConnectionTypes.RDP;
    this.verifyGuacAuthentication();
 }

  destroyed() {
    document.removeEventListener("click", this.refocusGuacamole);
    document.removeEventListener("keydown", this.refocusGuacamole);
 }

  private verifyGuacAuthentication() {
    if (this.isSSHConnection) {
      if (!isGuacAuthenticatedForTerminal()) {
        this.modalTitle = "Guacamole Terminal - Session expired";
        this.modalMessage =  "Session for Guacamole Terminal expired. Redirect for authentication.";
        this.dialogVisible = true;
     }
   } else {
      if (!isGuacAuthenticatedForDesktop()) {
        this.modalTitle = "Guacamole Desktop - Session expired";
        this.modalMessage =  "Session for Guacamole Desktop expired. Redirect for authentication.";
        this.dialogVisible = true;
     }
   }
 }

  private handleGuacAuthentication() {
    if (this.isSSHConnection) {
      authenticateGuacTerminal()
   } else {
      authenticateGuacDesktop()
   }
    this.dialogVisible = false;
 }

  private handleClose() {
    this.dialogVisible = false;
 }

  get isSSHConnection(): boolean {
    return this.connectionType === ConnectionTypes.SSH;
 }

  get isRDPConnection(): boolean {
    return this.connectionType === ConnectionTypes.RDP;
 }

  get isPSConnection(): boolean {
    return this.connectionType === ConnectionTypes.PS;
 }

  get isWRDPConnection(): boolean {
    return this.connectionType === ConnectionTypes.WRDP;
 }

  iframeLoad(e: any) {
 }

  navigateToConnection(connectionType: string) {
    let path: string = this.$router.currentRoute.path;
    let rootPath: string = path.substring(0, path.lastIndexOf('/'));
    switch(connectionType) {
      case "SSH": {
        if (this.connectionType !== ConnectionTypes.SSH) {
          this.$router.push({path: `${rootPath}/terminal`})
       }
        break;
     }
      case "RDP": {
        if (this.connectionType !== ConnectionTypes.RDP) {
          this.$router.push({path: `${rootPath}/rdp`})
       }
        break;
     }
      case "PS": {
          break;
     }
      case "WRDP": {
          break;
     }
   }
 }

  refocusGuacamole() {
    // Do not refocus if focus is on an input field
    let focused = document.activeElement;
    let controlPanelItem = (this.$refs.controlPanelItem as Vue)
      .$el as HTMLElement;

    let collapseContent = controlPanelItem.firstChild as HTMLElement;

    // if (focused && focused !== controlPanel)
    //   controlPanelItem.classList.remove("is-active");
    if (
      focused &&
      focused !== document.body &&
      focused !== collapseContent.firstChild
    )
      return;
    // Ensure iframe is focused
    let iframe = this.$refs.guac as HTMLElement;
    iframe.focus();
 }
}
